module.exports = __webpack_public_path__ + "img/ctt24-icon.10290f15.png";